var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "chevron_left_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#chevron_left_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.454 12l4.073 4.073c.138.139.21.313.212.522a.706.706 0 01-.212.532.717.717 0 01-.527.217.718.718 0 01-.527-.217L8.98 12.633A.83.83 0 018.723 12a.828.828 0 01.256-.633l4.494-4.494a.725.725 0 01.522-.212.707.707 0 01.532.212c.145.145.217.32.217.527a.717.717 0 01-.217.527L10.454 12z",
    fill: "#fff"
  }))));
}
export default SvgChevronLeft;